/**
 * Server-to-client Socket.IO message names for socket session control.
 * These are transport messages, not `broadcast:` application events.
 */
export enum WebsocketSessionMessageEnum {
  /** Access token is about to expire; the client should rotate and reconnect. */
  SESSION_EXPIRING = 'session_expiring',
  /** A server-initiated close is about to follow; the code says why. */
  SESSION_CLOSING = 'session_closing',
}
